<template>
  <WidgetLayout>
    <div class="flex justify-center items-center mt-2">
      <div class="w-96 min-h-[10px] bg-white p-6 shadow-md rounded">
        <div class="h-content m-auto justify-center items-center text-center">
          <LayupIcon />
          <h2 class="text-brand-700 font-bold m-2">Merchant</h2>
          <p class="text-sm m-2 text-gray-500">Generate an order.</p>
          <input
            v-model="apiKey"
            type="text"
            placeholder="API Key"
            class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-3"
          />

          <div class="w-full">
            <LayupButton
              @click="generateOrder()"
              type="button"
              :label="'Generate Order'"
              :isLoading="isLoading"
              data-testid="generate_order_button"
            />
          </div>

          <div v-if="errorMessage" class="text-error-600">{{ errorMessage }}</div>
          <div v-if="orderId" class="mt-2 text-sm text-gray-500">
            The generated order id is:
            <a :href="generatedOrderLink" class="text-brand-700 text-sm hover:text-brand-500"
              ><strong>{{ orderId }}</strong></a
            >
          </div>
        </div>
      </div>
    </div>
  </WidgetLayout>
</template>

<script setup lang="ts">
import LayupButton from '@/components/common/LayupButton.vue';
import LayupIcon from '@/components/icons/LayupIcon.vue';
import { BASE_URL } from '@/config';
import WidgetLayout from '@/layouts/WidgetLayout.vue';
import { createOrder } from '@/services/orders';
import dayjs from 'dayjs';
import { computed, ref } from 'vue';

const apiKey = ref('');
const orderId = ref(null);
const isLoading = ref(false);
const errorMessage = ref('');

const generatedOrderLink = computed(() => {
  return `${BASE_URL}/shopper/payment-plan/${orderId.value}`;
});

const generateOrder = async () => {
  isLoading.value = true;
  errorMessage.value = '';
  orderId.value = null;

  const productCount = Math.ceil(Math.random() * 5);

  const products = Array(productCount)
    .fill('')
    .map(() => ({
      amount: Math.ceil(Math.random() * 10000) + 10000,
      link: 'genarated-order',
      sku: 'generated-sku',
    }));

  const random = Math.floor(Math.random() * 6);
  const order = {
    products,
    endDateMax: dayjs().add(6, 'month').format(),
    endDateMin: dayjs().add(random, 'month').format(),
    depositPerc: 10,
    reference: 'generated',
    name: 'generated',
    imageUrl: 'image',
  } as any;

  try {
    const response = await createOrder(order, apiKey.value);
    orderId.value = response._id;
  } catch (err: any) {
    errorMessage.value = 'Something went wrong. Please try again!';
    if (err.response && err.response.data) {
      errorMessage.value = err.response.data;
    }
  } finally {
    isLoading.value = false;
  }
};
</script>
